import React, { FC } from "react";

import { defineMessages, useIntl } from "react-intl";

import { EntityTypeSupportingGroups } from "@mapmycustomers/shared/types/entity";
import { Button } from "@mapmycustomers/ui";

import AddOrCreateButton from "@app/component/preview/components/AddOrCreateButton";

import styles from "./NoData.module.scss";

const messages = defineMessages({
  addGroup: {
    id: "map.toolbar.groups.modal.noResults.addGroup",
    defaultMessage:
      "Add{entityType, select, accounts { Company} contacts { Person} deals { Deal} other {}} Group",
    description: "Add group button in  groups popover on the Map page",
  },
  clearSearch: {
    id: "map.toolbar.groups.modal.clearSearch",
    defaultMessage: "Clear Search",
    description: "Clear search button",
  },
  noGroups: {
    id: "map.toolbar.groups.modal.noGroups.title",
    defaultMessage:
      "No{entityType, select, accounts { company} contacts { person} deals { deal} other {}} groups",
    description: "No groups title",
  },
  noGroupsDescription: {
    id: "map.toolbar.groups.modal.noGroups.description",
    defaultMessage:
      "You don’t have any{entityType, select, accounts { company} contacts { person} deals { deal} other {}} groups yet.",
    description: "No groups description",
  },
  noResults: {
    id: "map.toolbar.groups.modal.noResults.title",
    defaultMessage: "No results",
    description: "No results title",
  },
  noResultsDescription: {
    id: "map.toolbar.groups.modal.noResults.description",
    defaultMessage: "Your search doesn’t have any results.",
    description: "No results description",
  },
});

export interface NoDataProps {
  addGroupDisabled: boolean;
  entityType: EntityTypeSupportingGroups;
  noGroups: boolean;
  onClearSearch: () => void;
  onCreateGroup: () => void;
}

const NoData: FC<NoDataProps> = ({
  addGroupDisabled,
  entityType,
  noGroups,
  onClearSearch,
  onCreateGroup,
}) => {
  const intl = useIntl();
  return (
    <div className={styles.noData}>
      {noGroups ? (
        <>
          <span className={styles.title}>
            {intl.formatMessage(messages.noGroups, { entityType })}
          </span>
          <span className={styles.description}>
            {intl.formatMessage(messages.noGroupsDescription, { entityType })}
          </span>
          <AddOrCreateButton
            className={styles.addButton}
            disabled={addGroupDisabled}
            label={intl.formatMessage(messages.addGroup, { entityType })}
            onClick={onCreateGroup}
          />
        </>
      ) : (
        <>
          <span className={styles.title}>{intl.formatMessage(messages.noResults)}</span>
          <span className={styles.description}>
            {intl.formatMessage(messages.noResultsDescription)}
          </span>
          <Button onClick={onClearSearch} type="text">
            {intl.formatMessage(messages.clearSearch)}
          </Button>
        </>
      )}
    </div>
  );
};

export default NoData;
